module.exports = __webpack_public_path__ + "static/media/forgot-password_mobile.8482b2dc.png";